<dashboard-loader *ngIf="loadingMetrics$ | async" [title]="'Loading Metrics...'"></dashboard-loader>
<div *ngIf="metricsLoaded$ | async" class="dashboard-unanswered-metrics-preview">
  <div
    *ngIf="!unansweredQuestions?.length; else unansweredMetricsTable"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxFlexOffset="30px"
  >
    No unanswered questions available
  </div>
  <ng-template #unansweredMetricsTable>
    <table class="dashboard-unanswered-metrics-preview__table">
      <tr class="dashboard-unanswered-metrics-preview__table-row">
        <th>Count</th>
        <th>Module name</th>
        <th>Module item question</th>
      </tr>

      <tbody *ngFor="let unansweredQuestion of unansweredQuestions">
        <tr
          class="dashboard-unanswered-metrics-preview__table-row dashboard-unanswered-metrics-preview__table-row--highlight"
          (click)="setSelectedUnansweredQuestion(unansweredQuestion)"
          [ngClass]="
            unansweredQuestion?.id === selectedUnansweredQuestion?.id
              ? 'dashboard-unanswered-metrics-preview__table-row--highlight-checked'
              : ''
          "
        >
          <td>{{ unansweredQuestion?.count }}</td>
          <td>{{ unansweredQuestion?.name }}</td>
          <td>{{ unansweredQuestion?.question | dashboardStripHtml }}</td>
        </tr>
      </tbody>
    </table>
  </ng-template>
</div>
